export default __webpack_public_path__ + "static/media/AmbassadorClosed.e19aebbd.jpg";